module.exports = __webpack_public_path__ + "static/media/icons-notification.b97ce112.png";